export default {
  loading: false,
  auctionIndicators: [],
  batchIndicators: [],
  receiptIndicators: []
};
